"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("circle", {
    cx: "249.1",
    cy: "169",
    r: "64.8"
  }), (0, _core.jsx)("path", {
    d: "M249.9 266.2c-64.5 0-119.2 47.4-128.3 111.2-1.2 8.9 5.1 17 14 18.2.7.1 1.3.1 2 .1h224.6c9 0 16.2-7.3 16.2-16.3 0-.7 0-1.3-.1-2-9.2-63.8-63.9-111.2-128.4-111.2z"
  }), (0, _core.jsx)("ellipse", {
    cx: "124.3",
    cy: "187.5",
    rx: "42.1",
    ry: "41.7"
  }), (0, _core.jsx)("path", {
    d: "M159.7 257.5c-27 19.1-48.1 45.4-61 75.8H52.2c-5.6.2-10.3-4.3-10.5-9.9 0-.6 0-1.2.1-1.8 5.8-41.3 41.4-72 83.1-71.7 12 0 23.9 2.5 34.8 7.6z"
  }), (0, _core.jsx)("circle", {
    cx: "375.1",
    cy: "187.5",
    r: "41.7"
  }), (0, _core.jsx)("path", {
    d: "M458.2 321.7c.8 5.6-3.1 10.8-8.6 11.6-.5.1-1 .1-1.6.1h-46.2c-12.9-30.4-33.8-56.6-60.6-75.8 10.6-4.9 22.1-7.5 33.7-7.5 41.8-.5 77.5 30.1 83.3 71.6z"
  }));
};

exports.default = _default;